var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plus_svg__a",
    d: "M9.516 13.834v1.872H6.448v3.328h-2.08v-3.328H1.3v-1.872h3.068v-3.328h2.08v3.328z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -10)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus_svg__a"
  }))));
};
export default SvgPlus;